import api from "../../api.js";

export async function updatePatientAllergiesAndConditions(patientId, payload) {
  const res = await api.put(`/api/clinic/patients/${encodeURIComponent(patientId)}/allergies-conditions`, payload);
  return res.data;
}
